/**
 * Enhanced CBT API endpoints for the new backend
 */
import { api, uploadFile } from './client';

export const cbtAPI = {
  // === Student Test Access ===
  getPassCodeInfo: (passCode) => api.get(`/cbt-route/pass-code/${passCode}`, { skipAuth: true }),
  verifyPassCode: (passCode) => api.post('/cbt-route/pass-code/verify', { pass_code: passCode }, { skipAuth: true }),
  // startTest: (passCode) => api.post('/cbt-route/test/start', { pass_code: passCode }),
  startTest: (payload) => 
    api.post('/cbt-route/test/start', payload),

  
  // === Test Session Management ===
  getTestSession: (sessionId) => api.get(`/cbt-route/test/session/${sessionId}`),
//   submitAnswer: (sessionId, questionId, answerData) => 
//     api.post(`/cbt-route/test/${sessionId}/answer`, { 
//       question_id: questionId,
//       answer: answerData 
//     }),
// In cbt.js - Update submitAnswer function
submitAnswer: (sessionId, questionId, answerData) => 
  api.post(`/cbt-route/test/${sessionId}/answer`, { 
    question_id: questionId,  // Send question_id at root level
    ...answerData  // Spread all answer data
  }),
  submitTest: (sessionId) => api.post(`/cbt-route/test/${sessionId}/submit`),
  getTestResults: (sessionId) => api.get(`/cbt-route/test/${sessionId}/results`),
  
  // === Questions & CBT Data ===
  getCBTQuestions: (cbtDataId) => api.get(`/cbt-route/${cbtDataId}/questions`),
  getCBTDetails: (cbtDataId) => api.get(`/cbt-route/${cbtDataId}`),
  
  // === Enhanced Features ===
  bulkCreateQuestions: (cbtDataId, questions) => 
    api.post(`/cbt-route/questions/bulk`, {
      cbt_data_id: cbtDataId,
      questions
    }),
  
  // === Modern CBT Creation ===
  createModernCBT: (cbtData) => api.post('/cbt-route/create', cbtData),
  updateCBT: (cbtId, cbtData) => api.put(`/cbt-route/${cbtId}`, cbtData),
  
  // === Student Management ===
  importStudents: (cbtPassCode, students) => 
    api.post('/cbt-route/import-students', {
      cbt_pass_code: cbtPassCode,
      students
    }),
  getImportedStudents: (cbtPassCode) => 
    api.get(`/cbt-route/${cbtPassCode}/imported-students`),
  
  // === Security & Monitoring ===
  createSecurityPhrase: (data) => api.post('/cbt-route/security-phrases/create', data),
  getSecurityPhrases: (cbtPassCode) => 
    api.get(`/cbt/security-phrases?cbt_pass_code=${cbtPassCode}`),
  
  // === Analytics & Results ===
  getCBTResults: (cbtDataId, params = {}) => 
    api.get(`/cbt/results/${cbtDataId}`, { params }),
  exportResults: (cbtDataId, format = 'csv') => 
    api.get(`/cbt/export/results/${cbtDataId}?format=${format}`),
  monitorSessions: (cbtDataId) => api.get(`/cbt/monitor/${cbtDataId}`),
  
  // === Session Management ===
  finalizeTest: (sessionId, backgroundTasks) => 
    api.post('/cbt/finalize', { session_id: sessionId, background_tasks: backgroundTasks }),
  
  // === File Upload ===
  uploadQuestionsFile: (cbtPassCode, file) => 
    uploadFile('/upload_docx/upload', file, { cbt_pass_code: cbtPassCode }),

  // === New endpoints from backend ===
  startCBTSession: (cbtDataId) => 
    api.post('/cbt/start', { cbt_data_id: cbtDataId }),
  
  submitAnswerV2: (answerData) => 
    api.post('/cbt/submit-answer', answerData),
  
  getStudentResults: (cbtDataId, testId = null) => 
    api.get(`/cbt/results/${cbtDataId}`, { params: { test_id: testId } }),



  // getStudentResultAnalytics: (testId) => 
  //   api.get(`/cbt-route/student/results/${testId}/analytics`),

  getStudentResultAnalytics: (testId) =>
  api.get(
    `/cbt-route/student/results/analytics?test_id=${encodeURIComponent(testId)}`
  ),

 
  /**
   * Get overall analytics for all tests taken by the student.
   * Returns overall_statistics (total tests, avg score, best score, pass rate, trend) 
   * and test_results array with summary of each test.
   */
  getAllStudentResultsAnalytics: () => 
    api.get('/cbt-route/student/results/all-analytics'),
};

export default cbtAPI;

